var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStackIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19,
    height: 17,
    viewBox: "0 0 19 17",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_3324",
    "data-name": "\\uADF8\\uB8F9 3324",
    transform: "translate(-430 -1039)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_1882",
    "data-name": "\\uC0AC\\uAC01\\uD615 1882",
    width: 19,
    height: 5,
    transform: "translate(430 1039)",
    fill: "#cacbd4"
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\uC0AC\\uAC01\\uD615_1883",
    "data-name": "\\uC0AC\\uAC01\\uD615 1883",
    transform: "translate(430 1045)",
    fill: "#fff",
    stroke: "#efeff3",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19,
    height: 5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 18,
    height: 4,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uC0AC\\uAC01\\uD615_1884",
    "data-name": "\\uC0AC\\uAC01\\uD615 1884",
    transform: "translate(430 1051)",
    fill: "#fff",
    stroke: "#efeff3",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19,
    height: 5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 18,
    height: 4,
    fill: "none"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStackIcon);
export default __webpack_public_path__ + "static/media/stackIcon.b9f75fe2af50b5384f23a2a14c6d11ad.svg";
export { ForwardRef as ReactComponent };